import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import * as css from './AiAgentInput.css';
import AiAgentSendIcon from '../../../../assets/icons/AiAgentSendIcon';
import AiAgentAttachmentIcon from '../../../../assets/icons/AiAgentAttachmentIcon';

interface AiAgentInputActionsProps {
    disableSubmit: boolean;
    onAttachClick: () => void;
    onSend: () => void;
}

function AiAgentInputActions({disableSubmit, onAttachClick, onSend}: AiAgentInputActionsProps) {
    const {t} = useTranslation('aiAgent');

    return (
        <css.actionsRow>
            <Button
                variant="subtle"
                size="category"
                iconStart={<AiAgentAttachmentIcon />}
                onClick={onAttachClick}
                ariaLabel={t('attachFile')}
                data-cy="ai-agent-attach"
            />
            <css.sendButton
                type="button"
                disabled={disableSubmit}
                $disabled={disableSubmit}
                onClick={onSend}
                aria-label={t('send')}
                data-cy="ai-agent-send"
            >
                <AiAgentSendIcon />
            </css.sendButton>
        </css.actionsRow>
    );
}

export default AiAgentInputActions;
